var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalldoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 2.5C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333C2.5 7.09057 3.99256 10.6939 6.64932 13.3507C9.30609 16.0074 12.9094 17.5 16.6667 17.5C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V13.75C17.5 13.529 17.4122 13.317 17.2559 13.1607C17.0996 13.0045 16.8877 12.9167 16.6667 12.9167C15.6333 12.9167 14.625 12.75 13.6917 12.4417C13.4 12.35 13.075 12.4167 12.8417 12.65L11.0083 14.4833C8.65 13.2833 6.725 11.35 5.51667 8.99167L7.35 7.15C7.58333 6.925 7.65 6.6 7.55833 6.30833C7.25 5.375 7.08333 4.36667 7.08333 3.33333C7.08333 3.11232 6.99554 2.90036 6.83926 2.74408C6.68298 2.5878 6.47101 2.5 6.25 2.5H3.33333ZM13.3333 2.5V5H10.8333V6.66667H13.3333V9.16667H15V6.66667H17.5V5H15V2.5",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalldoctorIcon);
export default __webpack_public_path__ + "static/media/calldoctor-icon.9e9cbc241f774729f50e6b9a34575c84.svg";
export { ForwardRef as ReactComponent };